'use client';
import React, { forwardRef } from 'react';
import { InputWrapper, InputWrapperAdditional, InputWrapperButton } from '@THC/components/__primitives__/InputWrapper';
import { CrossCircleIcon, EyeClosedIcon, EyeOpenIcon } from '@THC/components/Icons';
import { useInput } from './useInput';
export const Input = forwardRef((props, ref) => {
    const { append, as: InputElement = 'input', prepend, ...wrapperProps } = props;
    const { additionalsProps, clearInputButtonProps, inputProps, inputType, passwordVisibleProps, showClearInputButton, ...useInputRest } = useInput({ name: 'input', props, ref });
    const showPasswordEye = props.formProps?.input?.type === 'password';
    const hasAppend = showClearInputButton || showPasswordEye || append;
    return (<InputWrapper {...{
        ...wrapperProps,
        ...useInputRest,
    }} append={hasAppend && (<>
							{showClearInputButton && (<InputWrapperButton {...clearInputButtonProps}>
									<CrossCircleIcon size="small"/>
								</InputWrapperButton>)}

							{showPasswordEye && (<InputWrapperButton {...passwordVisibleProps}>
									{inputType === 'password' ? <EyeOpenIcon size="small"/> : <EyeClosedIcon size="small"/>}
								</InputWrapperButton>)}
							{append && <InputWrapperAdditional {...{ additionalsProps, append }}/>}
						</>)} prepend={prepend && <InputWrapperAdditional {...{ additionalsProps, prepend }}/>}>
				
				<InputElement {...inputProps}/>
			</InputWrapper>);
});
Input.displayName = 'Input';
